<template>
    <section ref="blockContainer" class="tile-blur tile">
        <header class="mb-4 flex grow-0 flex-col gap-4">
            <h2 v-if="title" class="order-2 text-2xl">{{ title }}</h2>
            <h3 v-if="subTitle" class="font-body order-1 uppercase">
                {{ subTitle }}
            </h3>
            <div v-if="body" class="order-last" v-html="body"></div>
        </header>
        <div class="grid">
            <ClientOnly>
                <swiper
                    class="w-full max-w-full min-w-0"
                    :slides-per-view="1.15"
                    :space-between="16"
                    :breakpoints="{
                        1024: {
                            slidesPerView: dimensions?.width < 1343 ? 1.15 : 2,
                            spaceBetween: 24,
                        },
                    }">
                    <swiper-slide v-for="(item, index) in pricingItems" :key="index">
                        <PricingItem v-bind="item" />
                    </swiper-slide>
                </swiper>
            </ClientOnly>
        </div>
    </section>
</template>
<script lang="ts" setup>
import type { PricingBlockModel } from '@su4r-frontend/api';
import { Swiper, SwiperSlide } from 'swiper/vue';

defineProps<PricingBlockModel>();
const { viewport } = useViewport();

const blockContainer = ref<HTMLElement | null>(null);
const dimensions = ref<DOMRect>({ width: 0 } as DOMRect);

onMounted(() => {
    if (blockContainer.value) {
        dimensions.value = blockContainer.value.getBoundingClientRect();
    }
});

watch(
    () => viewport.value,
    () => {
        if (blockContainer.value) {
            dimensions.value = blockContainer.value.getBoundingClientRect();
        }
    }
);
</script>

<style lang="css">
@import 'swiper/css';
</style>
